import { createStackNavigator } from '@react-navigation/stack';
import React, { ReactElement } from 'react';
import { Platform } from 'react-native';
import { createNativeStackNavigator } from 'react-native-screens/native-stack';

import {
  BLOCKED_USER_LIST_SCREEN,
  CHAT_SETTINGS_SCREEN,
} from '../../../shared/Constants';
import { LeftNavType } from '../../components/LeftNavButton';
import BlockedUserListScreen from '../../screens/BlockedUserListScreen';
import ChatSettingsScreen from '../../screens/ChatSettingsScreen';
import { getNavOptions } from '../navOptions';

const Stack =
  Platform.OS === 'web' ? createStackNavigator() : createNativeStackNavigator();

type Props = {
  onBackPress?: () => void;
};

export const ChatSettingsStack = ({
  onBackPress = undefined,
}: Props): ReactElement => {
  return (
    <Stack.Navigator
      screenOptions={{
        // @ts-ignore
        headerHideShadow: true,
        headerStyle: {
          borderBottomWidth: 0,
          elevation: 0,
          shadowColor: 'transparent',
        },
      }}
    >
      <Stack.Screen
        name={CHAT_SETTINGS_SCREEN}
        component={ChatSettingsScreen}
        options={(props) => ({
          ...getNavOptions(
            'User Settings',
            props,
            LeftNavType.Dismiss,
            onBackPress
          ),
        })}
      />
      <Stack.Screen
        name={BLOCKED_USER_LIST_SCREEN}
        component={BlockedUserListScreen}
        options={(props) => ({
          ...getNavOptions('Blocked', props),
        })}
      />
    </Stack.Navigator>
  );
};
